export default class RwStrings {
    static BaseTitle = "RoadWarrior";
}
